import {
  CrearCotizacion,
  ActualizarCotizacion,
  BuscarCotizacionActual,
  BuscarCotizacionPorCliente,
  Cargando,
  Error,
} from "../Types/Cotizacion.type";

const INITIAL_STATE = {
  Cotizaciones: [],
  Resultado: "",
  Mensaje: "",
  Cargando: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BuscarCotizacionActual:
      return {
        ...state,
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    case BuscarCotizacionPorCliente:
      return {
        ...state,
        Cotizaciones: action.payload,
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    case CrearCotizacion:
      return {
        ...state,
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    case ActualizarCotizacion:
      return {
        ...state,
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    case Cargando:
      return {
        ...state,
        Resultado: "",
        Mensaje: "",
        Cargando: true,
      };
    case Error:
      return {
        ...state,
        Resultado: "E",
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    default:
      return state;
  }
};
